// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content_wrapper__JWFW0","youtubeFrame":"Content_youtubeFrame__1U_V3","buttons":"Content_buttons__2tnqS","eventsBtn":"Content_eventsBtn__1BvrP"};